import { render, staticRenderFns } from "./bo-layout.vue?vue&type=template&id=c03c1336&"
import script from "./bo-layout.vue?vue&type=script&lang=js&"
export * from "./bo-layout.vue?vue&type=script&lang=js&"
import style0 from "./bo-layout.vue?vue&type=style&index=0&id=c03c1336&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports